import {
  ENDPOINT_MASTER_APPRENTICES_DISTRICT,
  ENDPOINT_MASTER_APPRENTICES_REGION,
  ENDPOINT_MASTER_APPRENTICES_REPUBLIC,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { create } from 'zustand';
import {
  MasterApprenticesDistrictResponse,
  type MasterApprentices,
  type MasterApprenticesRegionResponse,
  type MasterApprenticesRegions,
  type MasterApprenticesRepublic,
  type TMasterApprenticesStore,
} from '../models';

const httpApi = new HttpApi();

export const useMasterApprenticesStore = create<TMasterApprenticesStore>(
  (set) => ({
    masterApprenticesRepublicRates: null,
    masterApprenticesRepublic: [],
    masterApprenticesRepublicCachedAt: null,
    masterApprenticesRegions: [],
    masterApprenticesRegionsHeader: null,
    masterApprenticesDistrictHeader: null,
    masterApprentices: [],
    isMasterApprenticesRepublicLoading: false,
    isMasterApprenticesRegionLoading: false,
    isMasterApprenticesLoading: false,

    fetchMasterApprenticesRepublic: async () => {
      set({ isMasterApprenticesRepublicLoading: true });
      const res = await httpApi.get<{
        cachedAt: string;
        data: MasterApprenticesRepublic[];
      }>(ENDPOINT_MASTER_APPRENTICES_REPUBLIC, {});
      set({
        masterApprenticesRepublic: Array.isArray(res?.data)
          ? res.data.map((item, index) => ({
              id: index + 1,
              ...item,
            }))
          : [],
        masterApprenticesRepublicCachedAt: res?.cachedAt || null,
      });
      setTimeout(() => {
        set({ isMasterApprenticesRepublicLoading: false });
      }, 300);
    },

    fetchMasterApprenticesRegions: async (region_id) => {
      set({
        isMasterApprenticesRegionLoading: true,
      });
      const res = await httpApi.get<
        MasterApprenticesRegionResponse<MasterApprenticesRegions[]>
      >(ENDPOINT_MASTER_APPRENTICES_REGION, {
        region_id,
      });
      set({
        masterApprenticesRegions: res?.data.map((item, index) => ({
          id: index + 1,
          ...item,
        })),
        masterApprenticesRegionsHeader: {
          region_id: res?.region_id,
          region_name: res?.region_name,
        },
      });
      setTimeout(() => {
        set({ isMasterApprenticesRegionLoading: false });
      }, 300);
    },
    fetchMasterApprentices: async (district_id) => {
      set({
        isMasterApprenticesLoading: true,
      });
      const res = await httpApi.get<
        MasterApprenticesDistrictResponse<MasterApprentices[]>
      >(ENDPOINT_MASTER_APPRENTICES_DISTRICT, {
        district_id,
      });
      set({
        masterApprentices: res?.data?.map((item, index) => ({
          id: index + 1,
          ...item,
        })),
        masterApprenticesDistrictHeader: {
          region_id: res?.region_id,
          region_name: res?.region_name,
          district_id: res?.district_id,
          district_name: res?.district_name,
        },
      });
      setTimeout(() => {
        set({ isMasterApprenticesLoading: false });
      }, 300);
    },
  }),
);
